import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/stores/store';
import { UserActions } from '../../core/stores/user/user.actions';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-user-register',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule
  ],
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.scss']
})

export class UserRegisterComponent {
  newUsername: string = '';
  newFullname: string = '';
  newEmail: string = '';
  newPhone: string = '';
  newPassword: string = '';

  userId: number = 0;
  token: string = '';

  userForm: FormGroup;
  hidePassword: boolean = true;

  private readonly usernameNotEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').toString().trim();

    if (!value) {
      return null;
    }

    return Validators.email(control) === null ? { emailAddressNotAllowed: true } : null;
  };

  constructor(
    private store: Store<RootState>,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(this.translateService.getBrowserLang() || 'en');

    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] || '';
      this.userId = params['userId'] ? Number(params['userId']) : 0;

      if (!this.userId || !this.token) {
        alert('Faltan datos para generar el usuario.');
        this.router.navigate(['/login']);
      }

      this.store.dispatch(UserActions.setToken({ token: this.token }))

    });

    this.userForm = this.formBuilder.group({
      newUsername: [null, { validators: [Validators.required, this.usernameNotEmailValidator], updateOn: 'change' }],
      newFullname: [null, { validators: [Validators.required], updateOn: 'change' }],
      newPhone: [null, { validators: [Validators.required], updateOn: 'change' }],
      newPassword: [null, { validators: [Validators.required], updateOn: 'change' }]
    })
  }

  onSubmit() {
    const username = this.userForm.get('newUsername')?.value;
    const fullname = this.userForm.get('newFullname')?.value;
    const phone = this.userForm.get('newPhone')?.value;
    const password = this.userForm.get('newPassword')?.value;
    if (!username || !fullname || !phone || !password || password.length < 6 || this.userForm.invalid) {
      alert('Por favor, complete todos los campos.');
      return;
    }
    this.store.dispatch(UserActions.registerUser({ payload: { user_id: this.userId, username: username, name: fullname, phone: phone, password: password } }));
  }
}
